/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mild_Wry_Bird_NapInputs */

const en_mild_wry_bird_nap = /** @type {(inputs: Mild_Wry_Bird_NapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter last name...`)
};

const de_mild_wry_bird_nap = /** @type {(inputs: Mild_Wry_Bird_NapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachname eingeben...`)
};

/**
* | output |
* | --- |
* | "Enter last name..." |
*
* @param {Mild_Wry_Bird_NapInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mild_wry_bird_nap = /** @type {((inputs?: Mild_Wry_Bird_NapInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mild_Wry_Bird_NapInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mild_wry_bird_nap(inputs)
	return de_mild_wry_bird_nap(inputs)
});